import PropTypes from "prop-types";
import { useState } from "react";

import { usePostJson } from "hooks/use-fetch";

import { Button, Container, Link, Stack, Typography } from "components/core";

import { Svg as EmailIcon } from "./email.svg?svgr";

const UidEmailSent = ({ identifiedUser }) => {
  const [postSendEmail, loading] = usePostJson();
  const [emailSent, setEmailSent] = useState(false);

  const sendEmail = async () => {
    const response = await postSendEmail("/account/login/send-uid-email");

    if (response.redirectPath) {
      window.location.assign(response.redirectPath);
      return;
    }

    setEmailSent(true);
  };

  return (
    <Container disableGutters maxWidth="xs">
      <Stack alignItems="center" pb={10} pt={10} px={[2, 3]} spacing={5}>
        <EmailIcon />
        {!emailSent && (
          <>
            <Typography pb={[2, 3]} textAlign="center" variant="title">
              We can send an email to {identifiedUser.email} that you can use to
              log in.
            </Typography>
            <Button loading={loading} onClick={sendEmail}>
              Send login email
            </Button>
          </>
        )}
        {emailSent && (
          <Typography textAlign="center" variant="title">
            We’ve sent a login link to {identifiedUser.email}
          </Typography>
        )}

        <Link
          color="otherGreen.main"
          fontWeight="bold"
          href="/account/login?clear_uid=1"
        >
          Log in another way
        </Link>
      </Stack>
    </Container>
  );
};

UidEmailSent.propTypes = {
  identifiedUser: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
};

export default UidEmailSent;
